var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgriculturetype(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.222,
    height: 11.189,
    viewBox: "0 0 11.222 11.189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_87764",
    "data-name": "Path 87764",
    d: "M5.944,19.558a3.655,3.655,0,0,1,6.818,0,.391.391,0,0,1-.365.532H6.309a.391.391,0,0,1-.365-.532Z",
    transform: "translate(-3.482 -8.902)",
    fill: "#86899b",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87765",
    "data-name": "Path 87765",
    d: "M10.111,11.721a.391.391,0,1,1-.764-.17,8.622,8.622,0,0,0,0-3.271,4.122,4.122,0,0,0-1.9-2.83.392.392,0,0,1,.395-.676,4.889,4.889,0,0,1,2.273,3.341A9.494,9.494,0,0,1,10.111,11.721Z",
    transform: "translate(-4.119 -2.926)",
    fill: "#86899b",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87766",
    "data-name": "Path 87766",
    d: "M12.345,12.016a.391.391,0,1,1-.767-.154,4.222,4.222,0,0,1,1.351-2.034.392.392,0,0,1,.538.569,3.7,3.7,0,0,0-1.122,1.62Z",
    transform: "translate(-6.184 -5.317)",
    fill: "#86899b",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87767",
    "data-name": "Path 87767",
    d: "M14.119,9.22a3.078,3.078,0,0,1-.18-.937,1.657,1.657,0,0,1,.9-1.618,3.147,3.147,0,0,1,3.605.614.392.392,0,0,1-.172.628,2.221,2.221,0,0,0-1.078,1.108,2.3,2.3,0,0,1-1.354,1.055,1.484,1.484,0,0,1-.949-.032,1.25,1.25,0,0,1-.292-.166,5.489,5.489,0,0,1,.525-.566.392.392,0,0,0-.538-.569A6.508,6.508,0,0,0,14.119,9.22Z",
    transform: "translate(-7.316 -3.704)",
    fill: "#86899b",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_87768",
    "data-name": "Path 87768",
    d: "M5.438,6.036a1.57,1.57,0,0,1-.579.14A1.9,1.9,0,0,1,3.4,5.447a5.411,5.411,0,0,1-.81-1.283A9.3,9.3,0,0,0,1.35,2.434a.392.392,0,0,1,.134-.62,4.616,4.616,0,0,1,4.839.314,1.738,1.738,0,0,1,.62,1.863,4.174,4.174,0,0,1-.831,1.572L6.1,5.579A4.566,4.566,0,0,0,4.187,3.391a.392.392,0,0,0-.395.676A3.834,3.834,0,0,1,5.438,6.036Z",
    transform: "translate(-1.25 -1.283)",
    fill: "#86899b",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgriculturetype);
export default __webpack_public_path__ + "static/media/agriculturetype.8522ed077eb850e3a28305e50e8519e0.svg";
export { ForwardRef as ReactComponent };